import { takeLatest, put, call } from 'redux-saga/effects';
import { sendData, getPaginateCounts } from '../../network/dashboard/index';
import {
  SEND_MONITORING,
  GET_MONITORING_DATA,
  DATA,
  COUNTS_LIST_LOADED
} from './types';
import { FETCH_ERRORS, CLEAR_ERRORS } from '../error/types';
import { STATUS } from '../../config/constants/states';

function* getMonitoringData(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getPaginateCounts, payload.params);
    yield put({ type: DATA, payload: data });
    yield put({ type: COUNTS_LIST_LOADED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: COUNTS_LIST_LOADED, payload: false });
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* sendMonitoring(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendData, payload);
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    const { status, data } = e.response;
    yield put({
      type: FETCH_ERRORS, payload: {
        status: status || 500,
        message: data.message || 'Internal server error',
      }
    });
  }
};

function* watchGetMonitoring() {
  yield takeLatest(GET_MONITORING_DATA, getMonitoringData);
};

function* watchSendMonitoring() {
  yield takeLatest(SEND_MONITORING, sendMonitoring);
};

export default [
  watchGetMonitoring(),
  watchSendMonitoring()
];